const solutionsLinks = {
  digital_fraud: [
    {
      slug: '/solucoes/phishing/'
    },
    {
      slug: '/solucoes/malware/'
    },
    {
      slug: '/solucoes/pharming-e-fraudes-com-proxy/'
    }
  ],

  digital_brand: [
    {
      slug: '/solucoes/uso-indevido-de-marca/'
    },
    {
      slug: '/solucoes/uso-indevido-de-marca-em-buscas-pagas/'
    },
    {
      slug: '/solucoes/remove-fake-social-profiles/'
    },
    {
      slug: '/solucoes/nomes-de-dominios-similares/'
    },
    {
      slug: '/solucoes/apps-falsos/'
    },
    {
      slug: '/solucoes/apropriacao-de-identidade/'
    }
  ],

  data_leakage: [
    {
      slug: '/solucoes/vazamento-de-cartoes-de-credito/'
    },
    {
      slug: '/hashcast/'
    },
    {
      slug: '/solucoes/vazamento-de-base-de-dados-de-clientes/'
    },
    {
      slug: '/solucoes/vazamento-de-codigos-de-programacao/'
    },
    {
      slug: '/monitoramento-vazamentos-dados-lgpd/',
      showOnlyForLangs: ['pt', 'es']
    }
  ],

  sales_abuse: [
    {
      slug: '/solucoes/vendas-nao-autorizadas/'
    }
  ],

  executive_threats: [
    {
      slug: '/solucoes/vazamento-de-dados-de-executivos/'
    }
  ],

  threat_intelligence: [
    {
      slug: '/solucoes/fraudes-na-deep-e-dark-web/'
    }
  ],

  content_removal: [
    {
      slug: '/solucoes/takedown/'
    }
  ],

  digital_risk_analysis: [
    {
      slug: '/solucoes/servicos-gerenciados/'
    },
    {
      slug: '/solucoes/axur-research-team/'
    }
  ]
}
export default solutionsLinks
